type FetchOptions = {
  method: 'POST' | 'GET';
  url: string;
  data?: BodyInit;
  headers?: HeadersInit;
  signal?: AbortSignal;
};

export async function http<T>(options: FetchOptions): Promise<T> {
  const fetchOptions: RequestInit = {
    method: options.method,
    ...(options.headers ? { headers: options.headers } : {}),
  };

  if (options.data) {
    fetchOptions.body = options.data;
  }

  if (options.signal) {
    fetchOptions.signal = options.signal;
  }

  const response = await fetch(options.url, fetchOptions);
  const data: T = await response.json();

  return data;
}

export function toFormData(obj: Record<string, string | Blob>): FormData {
  const formData = new FormData();

  Object.entries(obj).forEach(([key, val]) => formData.append(key, val));

  return formData;
}

export function getCsrfToken(): Record<string, string> {
  const paramMeta = document.querySelector<HTMLMetaElement>(
    '[name="csrf-param"]',
  );
  const tokenMeta = document.querySelector<HTMLMetaElement>(
    '[name="csrf-token"]',
  );

  const param = paramMeta?.content;
  const token = tokenMeta?.content;

  return param && token ? { [param]: token } : {};
}

type NativeFormData = {
  method?: 'POST' | 'GET';
  action: string;
  data: Record<string, string>;
};

export function submitNativeForm({
  method = 'POST',
  action,
  data,
}: NativeFormData): void {
  const form = document.createElement('form');

  form.method = method;
  form.action = action;
  form.hidden = true;

  Object.entries(data).forEach(([key, value]) => {
    const hiddenField = document.createElement('input');

    hiddenField.type = 'hidden';
    hiddenField.name = key;
    hiddenField.value = value || '';

    form.appendChild(hiddenField);
  });

  document.body.appendChild(form);

  form.submit();
}
